import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { LayoutBaseDePagina } from "../../../shared/layouts"; // Layout do projeto
import { SetupFeeTab } from "./tabs/SetupFeeTab";
import { TabComission } from "./tabs/TabComission";

export const FinancialPassPresentation = () => {
	const [selectedTab, setSelectedTab] = useState(0); // Estado para gerenciar a tab selecionada

	// Função para controlar a mudança de tab
	const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
		setSelectedTab(newValue);
	};

	return (
		<LayoutBaseDePagina titulo="Repasses, Comissões e Bonificações" subtitulo="Controle de Repasses, Comissões , Bonificações" barraDeFerramentas={<></>}>
			<Tabs
				value={selectedTab}
				onChange={handleTabChange}
				aria-label="Repasses, Comissões e Bonificações"
				sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "background.paper", mx: 1, borderRadius: 1, bordercolor: "divider" }}
			>
				<Tab label="Bonificações" />
				<Tab label="Taxa Setup" />
			</Tabs>

			<Box sx={{ pt: 1 }}>
				{/* Tab de Cartão de Crédito */}
				{selectedTab === 0 && <TabComission />}

				{/* Tab de Faturamento */}
				{selectedTab === 1 && <SetupFeeTab />}

				{/* Tab de Boletos */}
			</Box>
		</LayoutBaseDePagina>
	);
};
